import { PropType } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';

type Props = SetupProps<typeof TempWorkerCommentSetupService.props>
type Emits = {(e: 'delete-comment', val: number): void};

export default class TempWorkerCommentSetupService extends BaseSetupService<Props> {
	static readonly props = {
		comment: {
			type: Object as PropType<IUserProfileCommentModel>,
			required: true as const,
		},
	};

	private emits: Emits;

	get postedDate () { return new Date(this.props.comment.createdDate).getTimeBetween(); }


	constructor (props: Props, emits: Emits) {
		super(props);
		this.emits = emits;
	}


	deleteComment (id: number) {
		this.emits('delete-comment', id);
	}
}
